import {
  CalendarDays,
  CheckCheck,
  FileText,
  MessageSquare,
  ListTodo,
  Bell,
} from "lucide-react";
import type { Notification as WorkspaceNotification } from "@sol-office/contracts";

export const changedEvent = "sol:notifications-changed";
export const revokedEvent = "sol:notifications-revoked";
export const signalNotificationChange = () =>
  window.dispatchEvent(new Event(changedEvent));
export function safeNotificationHref(
  href: string,
  workspaceId: string,
): string | null {
  try {
    const url = new URL(href, location.origin);
    return url.origin === location.origin &&
      url.pathname.startsWith(`/w/${workspaceId}/`)
      ? `${url.pathname}${url.search}${url.hash}`
      : null;
  } catch {
    return null;
  }
}
export function notificationTime(value: string): string {
  return new Intl.DateTimeFormat(undefined, {
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
  }).format(new Date(value));
}
export function NotificationIcon({
  source,
}: {
  source: WorkspaceNotification["source"]["kind"];
}) {
  const Icon =
    {
      chat: MessageSquare,
      calendar: CalendarDays,
      task: ListTodo,
      document: FileText,
    }[source] ?? Bell;
  return <Icon size={19} />;
}
export function NotificationCard({
  item,
  onOpen,
  onRead,
  onDismiss,
  busy = false,
}: {
  item: WorkspaceNotification;
  onOpen: () => void;
  onRead?: () => void;
  onDismiss?: () => void;
  busy?: boolean;
}) {
  return (
    <article
      className={`inbox-card ${item.readAt ? "read" : "unread"}`}
      data-notification-id={item.id}
    >
      <span className={`inbox-source-icon ${item.source.kind}`}>
        <NotificationIcon source={item.source.kind} />
      </span>
      <button className="inbox-content" onClick={onOpen} disabled={busy}>
        <span className="inbox-card-meta">
          <span>{item.kind.replaceAll(".", " · ")}</span>
          <time dateTime={item.createdAt}>
            {notificationTime(item.createdAt)}
          </time>
        </span>
        <strong>{item.title}</strong>
        {item.preview && <p>{item.preview}</p>}
        {item.actor && <small>{item.actor.name}</small>}
      </button>
      <div className="inbox-card-actions">
        {onRead && (
          <button
            className="icon-button"
            aria-label={
              item.readAt
                ? `Mark ${item.title} unread`
                : `Mark ${item.title} read`
            }
            disabled={busy}
            onClick={onRead}
          >
            <CheckCheck size={17} />
          </button>
        )}
        {onDismiss && (
          <button className="button quiet" disabled={busy} onClick={onDismiss}>
            {item.dismissedAt ? "Restore" : "Dismiss"}
          </button>
        )}
      </div>
    </article>
  );
}
